export default __webpack_public_path__ + "static/supportBg-a7f94e924f022dd77f1811ffb19600a1.png";